import { ComponentProps } from 'react';
import { useParams } from 'react-router';

import { BreadcrumbComponent } from '@fly/shared-ui';
import { Link as RadixLink } from '@radix-ui/themes';

export const StandaloneArtifactVersionsBreadcrumb: BreadcrumbComponent = ({
  isLast,
}: ComponentProps<BreadcrumbComponent>) => {
  const { artifactName } = useParams();

  return (
    <RadixLink className='text-fly-general-black'>
      <strong>{artifactName}</strong>
    </RadixLink>
  );
};
